export default "__VITE_ASSET__CtsHwOwI__"